import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.Payments.MessagePay.title',
    defaultMessage: 'Message Pay',
    description: '备注: 页面title',
  },
  p1: {
    id: 'routes.Payments.MessagePay.p1',
    defaultMessage: 'Trail on your one-click',
    description: 'p1',
  },
  smsPlaceholder: {
    id: 'routes.Payments.MessagePay.smsPlaceholder',
    defaultMessage: 'SMS code',
    description: 'smsPlaceholder',
  },
  btn: {
    id: 'routes.Payments.MessagePay.btn',
    defaultMessage: 'CLICK AND SIMPLE PAY',
    description: 'btn',
  },
  p2: {
    id: 'routes.Payments.MessagePay.p2',
    defaultMessage: 'Do not have a PayBy app?',
    description: 'p2',
  },
  p3: {
    id: 'routes.Payments.MessagePay.p3',
    defaultMessage: 'Register and download to experience further on scenarios and get your coupon by',
    description: 'p3',
  },
  link: {
    id: 'routes.Payments.MessagePay.link',
    defaultMessage: 'clicking here',
    description: 'link',
  },
  placeholder: {
    id: 'components.Capture.placeholder',
    defaultMessage: 'Verification code',
    description: 'placeholder',
  },
  errorMsg: {
    id: 'components.Capture.errorMsg',
    defaultMessage: 'Verification code required.',
    description: 'errorMsg',
  },
})
